import { QuestionComponentProps } from "..";

import { LocationSelector } from "./components/LocationSelector";

export function Location({
  setNextEnabled,
}: QuestionComponentProps): React.ReactElement {
  return (
    <LocationSelector
      onPreferenceSet={(isPreferenceSet: boolean) =>
        setNextEnabled?.(isPreferenceSet)
      }
      showRemote={true}
    />
  );
}
